export enum InputTypes {
  text = 'text',
  number = 'number',
  password = 'password',
  phone = 'phone',
  file = 'file'
}

export type InputType = (typeof InputTypes)[keyof typeof InputTypes];
